import axios from "@/utils/AxiosInstance.js";
import router from "../../router";
import ScorecardFilterKeys from "@/utils/ScorecardFilterKeys";
import { store } from "@/store/index.js";

export const scorecardsV2Aggregates = {
    namespaced: true,
    state: {
        aggregatedScorecardDynalabelData: {},
        aggregatedScorecardDynalabelDataLoadingStatus: 'notLoading',
        aggregatedScorecardDynalabelDataLoadingError: '',
        aggregatedScorecardDynalabelDataLoadingErrorStatus: false,

        groupedScorecardDynalabelData: {},
        groupedScorecardDynalabelDataLoadingStatus: 'notLoading',
        groupedScorecardDynalabelDataLoadingError: '',
        groupedScorecardDynalabelDataLoadingErrorStatus: false,

        aggregatedScorecardAgentData: {},
        aggregatedScorecardAgentDataLoadingStatus: 'notLoading',
        aggregatedScorecardAgentDataLoadingError: '',
        aggregatedScorecardAgentDataLoadingErrorStatus: false,

        groupedScorecardAgentData: {},
        groupedScorecardAgentDataLoadingStatus: 'notLoading',
        groupedScorecardAgentDataLoadingError: '',
        groupedScorecardAgentDataLoadingErrorStatus: false,

        displayFormats: [],

        agentRequestCount: 0,
        dynaRequestCount: 0,

        dynaTeamRowsLoaded: []

    },
    getters: {
        aggregatedScorecardDynalabelData: state => state.aggregatedScorecardDynalabelData,
        aggregatedScorecardDynalabelDataLoadingStatus: state => state.aggregatedScorecardDynalabelDataLoadingStatus,
        aggregatedScorecardDynalabelDataLoadingError: state => state.aggregatedScorecardDynalabelDataLoadingError,
        aggregatedScorecardDynalabelDataLoadingErrorStatus: state => state.aggregatedScorecardDynalabelDataLoadingErrorStatus,

        groupedScorecardDynalabelData: state => state.groupedScorecardDynalabelData,
        groupedScorecardDynalabelDataLoadingStatus: state => state.groupedScorecardDynalabelDataLoadingStatus,
        groupedScorecardDynalabelDataLoadingError: state => state.groupedScorecardDynalabelDataLoadingError,
        groupedScorecardDynalabelDataLoadingErrorStatus: state => state.groupedScorecardDynalabelDataLoadingErrorStatus,

        aggregatedScorecardAgentData: state => state.aggregatedScorecardAgentData,
        aggregatedScorecardAgentDataLoadingStatus: state => state.aggregatedScorecardAgentDataLoadingStatus,
        aggregatedScorecardAgentDataLoadingError: state => state.aggregatedScorecardAgentDataLoadingError,
        aggregatedScorecardAgentDataLoadingErrorStatus: state => state.aggregatedScorecardAgentDataLoadingErrorStatus,

        groupedScorecardAgentData: state => state.groupedScorecardAgentData,
        groupedScorecardAgentDataLoadingStatus: state => state.groupedScorecardAgentDataLoadingStatus,
        groupedScorecardAgentDataLoadingError: state => state.groupedScorecardAgentDataLoadingError,
        groupedScorecardAgentDataLoadingErrorStatus: state => state.groupedScorecardAgentDataLoadingErrorStatus,

        displayFormats: state => state.displayFormats,

        agentRequestCount: state => state.agentRequestCount,
        dynaRequestCount: state => state.dynaRequestCount,

        dynaTeamRowsLoaded: state => state.dynaTeamRowsLoaded,

    },
    mutations: {

        SET_AGENT_REQUEST_COUNT(state, count) {
            state.agentRequestCount = count
        },

        SET_DYNA_REQUEST_COUNT(state, count) {
            state.dynaRequestCount = count
        },
 
        SET_DISPLAY_FORMATS(state, displayFormats) {
            state.displayFormats = displayFormats
        },

        SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA(state, aggregatedData) {
            state.aggregatedScorecardDynalabelData = aggregatedData
        },
        SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS(state, status) {
            state.aggregatedScorecardDynalabelDataLoadingStatus = status
        },
        SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR(state, error) {
            state.aggregatedScorecardDynalabelDataLoadingError = error
        },
        SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS(state, status) {
            state.aggregatedScorecardDynalabelDataLoadingErrorStatus = status
        },

        SET_SCORECARDS_GROUPED_DYNALABEL_DATA(state, groupedData) {
            state.groupedScorecardDynalabelData = groupedData
        },
        SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS(state, status) {
            state.groupedScorecardDynalabelDataLoadingStatus = status
        },
        SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR(state, error) {
            state.groupedScorecardDynalabelDataLoadingError = error
        },
        SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS(state, status) {
            state.groupedScorecardDynalabelDataLoadingErrorStatus = status
        },

        SET_SCORECARDS_AGGREGATED_AGENT_DATA(state, aggregatedData) {
            state.aggregatedScorecardAgentData = aggregatedData
        },
        SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS(state, status) {
            state.aggregatedScorecardAgentDataLoadingStatus = status
        },
        SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR(state, error) {
            state.aggregatedScorecardAgentDataLoadingError = error
        },
        SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR_STATUS(state, status) {
            state.aggregatedScorecardAgentDataLoadingErrorStatus = status
        },

        SET_SCORECARDS_GROUPED_AGENT_DATA(state, groupedData) {
            state.groupedScorecardAgentData = groupedData
        },
        SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS(state, status) {
            state.groupedScorecardAgentDataLoadingStatus = status
        },
        SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR(state, error) {
            state.groupedScorecardAgentDataLoadingError = error
        },
        SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS(state, status) {
            state.groupedScorecardAgentDataLoadingErrorStatus = status
        },
        
        SET_DYNA_TEAM_ROWS_LOADED(state, dynaTeamRowsLoaded) {
            state.dynaTeamRowsLoaded = dynaTeamRowsLoaded
        }
    },
    actions: {
        addToAgentRequestCount(context, count) {
            let currReqCount = context.getters.agentRequestCount
            context.commit("SET_AGENT_REQUEST_COUNT", currReqCount += count)
        },
        addToDynaRequestCount(context, count) {
            let currReqCount = context.getters.dynaRequestCount
            context.commit("SET_DYNA_REQUEST_COUNT", currReqCount += count)
        },
        resetDynaRequestCount(context) {
            context.commit("SET_DYNA_REQUEST_COUNT", 0)
        },
        resetAgentRequestCount(context) {
            context.commit("SET_AGENT_REQUEST_COUNT", 0)
        },
        retrieveScorecardsAggregatedDynaLabelData(context, payload) {

            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'
           
            context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", [])

            // load presentation data as this is the first call that should load to the UI
            let display_formats = [];
            let presentation = payload.presentation
            presentation.forEach((presented, index) => {
                if (presented.source_key.includes('data[].items[]')) {
                    let key = presented.source_key.substr(presented.source_key.lastIndexOf('.') + 1);
                    let info = {}
                    info[key] = {
                        display: presented.display_format,
                        data_type: presented.data_type,
                    }
                    display_formats.push(info)
                } 
            })
            
            context.commit("SET_DISPLAY_FORMATS", display_formats)

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/0' + urlParams)
                .then(response => {

                    if (ScorecardFilterKeys.dynaFilterKeyMatch(payload)) {
                        let aggregatedDynalabels = response.data.data

                        aggregatedDynalabels.categories = aggregatedDynalabels.categories.map(obj => ({ ...obj, loading: true }))
                        if (store.getters['resources/teamByUserData'].length > 0 && 
                            store.getters['resources/teamByUserData'].filter((team) => {return team.associations.filter(assoc => assoc.profile_type == 0).length > 0}).length > 0) {
                            aggregatedDynalabels.items = aggregatedDynalabels.items.map(obj => ({ ...obj, expanded: false,
                                teams: store.getters['resources/teamByUserData']
                                .filter((team) => {
                                    return team.associations.filter(assoc => assoc.profile_type == 0).length > 0
                                }) 
                                .map((item) => ({
                                    team_id: item.id,
                                    team_name: item.team_name
                                })) 
                            }))
                        } else {
                            aggregatedDynalabels.items = aggregatedDynalabels.items.map(obj => ({ ...obj, expanded: false}))
                        }
               
                        aggregatedDynalabels.items.forEach((item, index) => {
                            item.metrics.categories.sort(
                                (a, b) => (a.sort_order > b.sort_order && 1) || -1
                            );
                        })
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", aggregatedDynalabels)
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS", false)
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR", "")
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "loaded")
                    }
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", {})
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveScorecardsAggregatedDynaLabelData() ')
                })
        },

        setGroupedDynalabelLoadingStatus(context, status) {
            context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", status)
        },
        setAggregateDynalabelLoadingStatus(context, status) {
            context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", status)
        },
        setGroupedAgentLoadingStatus(context, status) {
            context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", status)
        },
        setAggregatedAgentLoadingStatus(context, status) {
            context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS", status)
        },
        retrieveScorecardsGroupedDynaLabelData(context, payload) {
            let axios_params = {
                headers: {},
                params: {
                    start_date: payload.start_date,
                    end_date: payload.end_date,
                    grouping: payload.grouping,
                    scorecards_editor: false,
                    group_by_dynalabel: true,
                    call_type: payload.call_type,
                }
            }
            let axios_url = process.env.VUE_APP_SCORECARDS_V2 + "/" + payload.scorecard_id + "/dynalabels"
    
            if(payload.selfSigned) {
                axios_url = process.env.VUE_APP_AUTHENTICATE_ROUTE
                axios_params['headers'] = {"Authorization": payload.userid + " " + payload.reckey}
                axios_params['params']['scorecard_id'] = payload.scorecard_id
                axios_params['params']['route'] = "scorecard_dynalabel_info"
                axios_params['params']['call_id'] = payload.call_id
            } 

            context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
            axios
                .get(axios_url, axios_params)
                .then(response => {
                    let groupedDynalabels = response.data.data
                    groupedDynalabels.categories = groupedDynalabels.categories.map(obj => ({ ...obj, loading: true, expanded: false }))
                    groupedDynalabels.items = groupedDynalabels.items.sort(
                        (a, b) => (a.dynalabelTitle > b.dynalabelTitle && 1) || -1
                    );
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", groupedDynalabels)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", false)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", "")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "loaded")
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveScorecardsGroupedDynaLabelData()')
                })
        },

        retrieveScorecardsAggregatedAgentData(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'

            if (payload.team_id) {
                urlParams += '&team_id=' + payload.team_id
            }

            let presentation = payload.presentation
            let display_formats = [];
            presentation.forEach((presented, index) => {
                if (presented.source_key.includes('data[].items[]')) {
                    let key = presented.source_key.substr(presented.source_key.lastIndexOf('.') + 1);
                    let info = {}
                    info[key] = {
                        display: presented.display_format,
                        data_type: presented.data_type,
                    }

                    display_formats.push(info)
                } 
            })
            
            context.commit("SET_DISPLAY_FORMATS", display_formats)
          
            context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA", [])
            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents/0' + urlParams)
                .then(response => {
                    
                    if (ScorecardFilterKeys.agentFilterKeyMatch(payload)) {
                        let aggregatedAgents = response.data.data
                        
                        aggregatedAgents.categories = aggregatedAgents.categories.map(obj => ({ ...obj, loading: true }))
                        aggregatedAgents.categories = aggregatedAgents.categories.sort(
                            (a, b) => (a.sort_order > b.sort_order && 1) || -1
                        );
                        context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA", aggregatedAgents)
                        context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR_STATUS", false)
                        context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR", "")
                        context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS", "loaded")
                    }
                    
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA", {})
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR", 'retrieveScorecardsAggregatedAgentData()')
                })
        },

        retrieveScorecardsGroupedAgentData(context, payload) {

            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&group_by_agent=true'
            urlParams += '&call_type=' + payload.call_type

          
            context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents/' + urlParams)
                .then(response => {
                    let groupedAgents = response.data.data
                    groupedAgents.categories = groupedAgents.categories.map(obj => ({ ...obj, loading: true }))
                    groupedAgents.items = groupedAgents.items.sort(
                        (a, b) => (a.agentName > b.agentName && 1) || -1
                    );
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", groupedAgents)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", false)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", "")
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "loaded")
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", 'retrieveScorecardsGroupedAgentData()')
                })
        },

        retrieveAggregateDynalabelIds(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&dyna_scope=1'

            context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + urlParams)
                .then(response => {

                    let dynaIds = response.data.data
                    let groupDynaSkeleton = []
                    dynaIds.forEach(value => {
                        let dynaSkeleton = {
                            key:value,
                            loading: true,
                            expanded: false,
                           
                        }
                        if (store.getters['resources/teamByUserData'].length > 0 && 
                            store.getters['resources/teamByUserData'].filter((team) => {return team.associations.filter(assoc => assoc.profile_type == 0).length > 0}).length > 0) {
                            dynaSkeleton.teams = store.getters['resources/teamByUserData']
                                .filter((team) => {
                                    return team.associations.filter(assoc => assoc.profile_type == 0).length > 0
                                })
                                .map(item => ({
                                    team_id: item.id,
                                    team_name: item.team_name
                                }))
                        }
                        groupDynaSkeleton.push(dynaSkeleton)
                    })

                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", groupDynaSkeleton)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", false)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", "")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "loaded")
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveAggregateDynalabelIds()')

                })
        },

        retrieveAggregatedDynalabelCategories(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&loadmore=categories'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'

            if (payload.categories) {
                payload.categories.forEach(value => {
                    urlParams += '&category_ids[]=' + JSON.stringify(value)
                })
            }

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/0' + urlParams)
                .then(response => {
                    
                    if (ScorecardFilterKeys.dynaFilterKeyMatch(payload)) {
                        //once this loads, splice the list and update it
                        let currentList = context.getters.aggregatedScorecardDynalabelData
                        let categoriesRetrieved = response.data.data
                    
                        currentList.categories.forEach((category, index) => {
                            categoriesRetrieved.forEach((categoryResponse, responseIndex) => {
                                if (category.id == categoryResponse.id) {
                                    categoryResponse.loading = false
                                    //splice is a requirement to update the index
                                    currentList.categories.splice(index, 1, categoryResponse)
                                }
                            })
                        })
                    }
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", {})
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveAggregatedDynalabelCategories() ')
                })

        },

        retrieveAggregatedAgentCategories(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&loadmore=categories'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'
           
            if (payload.categories) {
                payload.categories.forEach(value => {
                    urlParams += '&category_ids[]=' + JSON.stringify(value)
                })
            }

            if (payload.team_id) {
                urlParams += '&team_id=' + payload.team_id
            }

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents/0' + urlParams)
                .then(response => {
                    
                    if (ScorecardFilterKeys.agentFilterKeyMatch(payload)) {
                        //once this loads, splice the list and update it
                        let categoriesRetrieved = response.data.data
                        let currentList = context.getters.aggregatedScorecardAgentData
                        currentList.categories.forEach((category, index) => {
                            categoriesRetrieved.forEach((categoryResponse, responseIndex) => {
                                if (category.id == categoryResponse.id) {
                                    categoryResponse.loading = false
                                    category.loading = false
                                    //splice is a requirement to update the index
                                    currentList.categories.splice(index, 1, categoryResponse)
                                }

                            })
                        })
                    }
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA", [])
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_AGGREGATED_AGENT_DATA_LOADING_ERROR", 'retrieveAggregatedAgentCategories()')
                })

        },

        retrieveDynalabelRow(context, payload) {
            //retrieves dynamic label row data
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'

            if (payload.dyna_query_ids) {
                payload.dyna_query_ids.forEach(value => {
                    urlParams += '&dyna_query_ids[]=' + JSON.stringify(value)
                })

                urlParams += '&group_by_dynalabel=true'
            }

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + urlParams)
                .then(response => {

                    // if filter array contains the filter and the request payload.call_type and payload.start_date and payload.end_date does not equal the requested filter, dont do anything, the request will come back around
                    // else request the data to be spliced

                    if (ScorecardFilterKeys.dynaFilterKeyMatch(payload)) {
                        context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 1)

                        //once this loads, splice the list and update it
                        let dynalabelData = response.data.data.items
                        let currentList = context.getters.groupedScorecardDynalabelData
                
                        currentList.forEach((item, index) => {
                            dynalabelData.forEach((dynalabelItem, agentIndex) => {
                                if (item.key == dynalabelItem.itemId) {
                                    if (dynalabelItem.metrics.totalCalls < 1) {

                                        // we dont need to send extra dynalabel requests if the dyna has no calls...
                                        if (payload.dyna_query_ids) {
                                            const dynaQueryIndex = payload.dyna_query_ids.findIndex(id => id == dynalabelItem.itemId);
                                            if (dynaQueryIndex > -1) {
                                                payload.dyna_query_ids.splice(dynaQueryIndex, 1);
                                            }
                                        }

                                    }
                                    let dynaItemSplice = dynalabelItem
                                    dynaItemSplice.teams = item.teams
                                    dynaItemSplice.expanded = item.expanded
                                    currentList.splice(index, 1, dynaItemSplice)
                                }
                            })
                        })

                        context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", currentList)

                        // retrieve the categories for the dynamic label that just loaded
                        context.dispatch("retrieveDynalabelRowCategories", payload)
                    } else {
                        //decrement again since we did not send the category request
                        context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 2)
                    }
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRow()')
                })
        },

        retrieveDynalabelTeamRow(context, payload) {
            //retrieves dynamic label row data
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'

            if (payload.team_ids) {
                payload.team_ids.forEach(value => {
                    urlParams += '&team_ids[]=' + JSON.stringify(value)
                })
            }

            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + urlParams)
                .then(response => {

                    // if filter array contains the filter and the request payload.call_type and payload.start_date and payload.end_date does not equal the requested filter, dont do anything, the request will come back around
                    // else request the data to be spliced

                    let teamData = response.data.data
                    if (ScorecardFilterKeys.dynaFilterKeyMatch(payload)) {
                        context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 1)

                        let teamsToRemove = []
                        //once this loads, splice the list and update it
                        let currentList = (payload.aggregate_row) ? context.getters.aggregatedScorecardDynalabelData.items : context.getters.groupedScorecardDynalabelData
                        currentList.forEach((item, listIndex) => {
                            item.teams.forEach((team, teamIndex) => {
                                teamData.items.forEach((teamItem, listIndex) => {
                                    if (team.team_id == teamItem.itemId && item.itemId == payload.dyna_row_id) {
                                        if (teamItem.metrics.totalCalls < 1) {
                                            teamsToRemove.push(teamItem.itemId)
                                        } else {
                                            let newTeam = teamItem
                                            newTeam.team_id = teamItem.itemId
                                            newTeam.team_name = team.team_name
                                            newTeam.loaded = true
                                            item.teams.splice(teamIndex, 1, newTeam)
                                        }
                                    }
                                })
                            })
                        })

                        // remove teams that have no calls from the request array and the dynalabel team list
                        currentList.forEach((item) => {

                            //loop backwards while removing items from the array
                            for (let teamIndex = item.teams.length - 1; teamIndex >= 0; teamIndex--) {
                                const team = item.teams[teamIndex];
                                if (teamsToRemove.includes(team.team_id) && item.itemId == payload.dyna_row_id) {
                                    if (payload.team_ids) {
                                        const payloadTeamIndex = payload.team_ids.findIndex(id => id == team.team_id);
                                        if (payloadTeamIndex > -1) {
                                            payload.team_ids.splice(payloadTeamIndex, 1);
                                        }
                                    }
                                    item.teams.splice(teamIndex, 1);
                                }
                            }
                        });

                        // retrieve the categories for the dynamic label that just loaded
                        context.dispatch("retrieveDynalabelTeamRowCategories", payload)
                    } else {
                        //decrement again since we did not send the category request
                        context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 2)
                    }
                })
                .catch(function (error) {
                    if (payload.aggregate_row){
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", [])
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                        context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRowCategories()')
                    } else {
                        context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                        context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                        context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                        context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRowCategories()')
                    }
                })
        },

        retrieveDynalabelRowCategories(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'
            urlParams += '&loadmore=categories'

            if (payload.dyna_query_ids) {
                payload.dyna_query_ids.forEach(value => {
                    urlParams += '&dyna_query_ids[]=' + JSON.stringify(value)
                })

                urlParams += '&group_by_dynalabel=true'
            }
           
            axios
            .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + urlParams)
            .then(response => {
                context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 1)

                let currentGroupedDynaList = context.getters.groupedScorecardDynalabelData
                let itemsRetrieved = response.data.data

                currentGroupedDynaList.forEach((item, index) => {
                    if (itemsRetrieved[item.itemId]) {
                        itemsRetrieved[item.itemId].forEach((catRetrieved, retrievedIndex) => {
                            item.metrics.categories.forEach((catItem, catIndex) => {

                                if (catItem.id == catRetrieved.id) {
                                    catItem.loading = false
                                    item.metrics.categories.splice(catIndex, 1, catRetrieved)

                                    item.metrics.categories.sort(
                                        (a, b) => (a.sort_order > b.sort_order && 1) || -1
                                    );
                                }
                            })
                        })
                    }
                })

            })
            .catch(function (error) {
                context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRowCategories()')
            })
        },

        retrieveDynalabelTeamRowCategories(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'
            urlParams += '&loadmore=categories'

            if (payload.team_ids) {
                payload.team_ids.forEach(value => {
                    urlParams += '&team_ids[]=' + JSON.stringify(value)
                })
            }
           
            axios
            .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + urlParams)
            .then(response => {
                context.commit("SET_DYNA_REQUEST_COUNT", context.getters.dynaRequestCount - 1)

                let currentGroupedDynaList = (payload.aggregate_row) ? context.getters.aggregatedScorecardDynalabelData.items : context.getters.groupedScorecardDynalabelData
                let categoriesRetrieved = response.data.data

                currentGroupedDynaList = currentGroupedDynaList.map(item => {

                    if (item.itemId == payload.dyna_row_id) {
                        // Process teams
                        item.teams = item.teams.map(team => {
                            if (categoriesRetrieved[team.team_id]) {
                                categoriesRetrieved[team.team_id].forEach((catRetrieved, retrievedIndex) => {
                                    team.metrics.categories.forEach((teamCatItem, catIndex) => {
                                        if (teamCatItem.id == catRetrieved.id) {
                                            catRetrieved.loaded = true
                                            team.metrics.categories.splice(catIndex, 1, catRetrieved)
                                            team.metrics.categories.sort(
                                                (a, b) => (a.sort_order > b.sort_order && 1) || -1
                                            );
                                        }
                                    })
                                })
                            }
                            return team;  // Return the updated team
                        });

                    }

                })
             
            })
            .catch(function (error) {
                if (payload.aggregate_row){
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA", [])
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_AGGREGATED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRowCategories()')
                } else {
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_DYNALABEL_DATA_LOADING_ERROR", 'retrieveDynalabelRowCategories()')
                }

            })
        },

        retrieveAggregateAgentIds(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&agent_scope=1'

            if (payload.team_id) {
                urlParams += '&team_id=' + payload.team_id
            }

            context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "loading")
            context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents' + urlParams)
                .then(response => {

                    let agentIds = response.data.data
                    let groupAgentSkeleton = []
                    agentIds.forEach(value => {
                        groupAgentSkeleton.push({
                            key:value,
                            loading: true
                        })
                    })

                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", groupAgentSkeleton)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", false)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", "")
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "loaded")
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", 'retrieveAggregateDynalabelIds()')

                })
        },

        retrieveAgentRow(context, payload) {
            //retrieves dynamic label row data
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'

            if (payload.agent_query_ids) {
                payload.agent_query_ids.forEach(value => {
                    urlParams += '&agent_query_ids[]=' + JSON.stringify(value)
                })

                urlParams += '&group_by_agent=true'
            }
            if (payload.team_id) {
                urlParams += '&team_id=' + payload.team_id
            }
            axios
                .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents/' + urlParams)
                .then(response => {

                    if (ScorecardFilterKeys.agentFilterKeyMatch(payload)) {
                        context.commit("SET_AGENT_REQUEST_COUNT", context.getters.agentRequestCount - 1)

                        //once this loads, splice the list and update it
                        let currentList = context.getters.groupedScorecardAgentData
                        let agentData = response.data.data.items
                
                        currentList.forEach((item, index) => {
                            agentData.forEach((agentItem, agentIndex) => {
                                if (item.key == agentItem.itemId) {
                                    currentList.splice(index, 1, agentItem)
                                }
                            })
                        })

                        context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", currentList)
                    
                        // retrieve the categories for the agent that just loaded
                        context.dispatch("retrieveAgentRowCategories", payload)
                    } else {
                        context.commit("SET_AGENT_REQUEST_COUNT", context.getters.agentRequestCount - 1)
                    }
                })
                .catch(function (error) {
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "failed")
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                    context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", 'retrieveAgentRow()')
                })
        },

        retrieveAgentRowCategories(context, payload) {
            let urlParams = "?"
            urlParams += '&start_date=' + payload.start_date
            urlParams += '&end_date=' + payload.end_date
            urlParams += '&grouping=' + payload.grouping
            urlParams += '&scorecards_editor=false'
            urlParams += '&call_type=' + payload.call_type
            urlParams += '&new_queries=1'
            urlParams += '&loadmore=categories'

            if (payload.agent_query_ids) {
                payload.agent_query_ids.forEach(value => {
                    urlParams += '&agent_query_ids[]=' + JSON.stringify(value)
                })

                urlParams += '&group_by_agent=true'
            }
            if (payload.team_id) {
                urlParams += '&team_id=' + payload.team_id
            }

            axios
            .get(process.env.VUE_APP_SCORECARDS_V2 + '/' + payload.scorecard_id + '/dynalabels/' + payload.dynalabel_id + '/agents/' + urlParams)
            .then(response => {

                context.commit("SET_AGENT_REQUEST_COUNT", context.getters.agentRequestCount - 1)

                let currentGroupedAgentList = context.getters.groupedScorecardAgentData
                let itemsRetrieved = response.data.data

                currentGroupedAgentList.forEach((item, index) => {

                    if (itemsRetrieved[item.itemId]) {
                        itemsRetrieved[item.itemId].forEach((catRetrieved, retrievedIndex) => {
                            item.metrics.categories.forEach((catItem, catIndex) => {

                                if (catItem.id == catRetrieved.id) {
                                    catItem.loading = false
                                    item.metrics.categories.splice(catIndex, 1, catRetrieved)

                                    item.metrics.categories.sort(
                                        (a, b) => (a.sort_order > b.sort_order && 1) || -1
                                    );
                                }
                            })
                        })
                    }
                })
            })
            .catch(function (error) {
                context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_STATUS", "failed")
                context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA", [])
                context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR_STATUS", true)
                context.commit("SET_SCORECARDS_GROUPED_AGENT_DATA_LOADING_ERROR", 'retrieveAgentlRowCategories()')
            })
        },
        setDynaLabelExpand(context, params) {

            //once this loads, splice the list and update it
            let currentList = context.getters.groupedScorecardDynalabelData
            currentList.forEach((item, index) => {
                if (item.hasOwnProperty("metrics") && (item.metrics.hasOwnProperty("totalCalls") && item.metrics.totalCalls > 0
                || item.metrics.hasOwnProperty("excludedCallCount") && item.metrics.excludedCallCount > 0) && item.itemId == params.id) {
                    item.expanded = params.expanded
                }
            })
        },
        setDynaLabelAggExpand(context, params) {

            //once this loads, splice the list and update it
            let aggregateData = context.getters.aggregatedScorecardDynalabelData
            aggregateData.items.forEach((item, index) => {
                if (item.metrics.totalCalls > 0 || item.metrics.excludedCallCount > 0) {
                    item.expanded = params.expanded
                }
            })
        },

        pushDynaTeamReqId(context, dyna_team_id) {
            let currentDynaTeamsLoaded = context.getters.dynaTeamRowsLoaded
            currentDynaTeamsLoaded.push(dyna_team_id)
            context.commit("SET_DYNA_TEAM_ROWS_LOADED", currentDynaTeamsLoaded)
        },
        clearDynaTeamReqIds(context) {
            context.commit("SET_DYNA_TEAM_ROWS_LOADED", [])
        }
    },

    
}
